module.exports = __webpack_public_path__ + "static/media/maintenance.aac8b18f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/home/Banner/maintenance.svg
 ** module id = 1323
 ** module chunks = 0
 **/